<template>
    <div class="grey lighten-4">
        <v-card v-if="page" fill-height>
            <v-card-text>
                <v-form ref="form">
                     <!-- Title -->
                    <v-text-field
                        id="title"
                        :label="$t('page.save.form.title')"
                        name="title"
                        :rules="[
                            rules.required,
                            rules.min_length(3),
                            rules.max_length(255),
                        ]"
                        counter="255"
                        color="primary"
                        type="text"
                        v-model="page.title"
                    ></v-text-field>
                    <!-- Meta Title -->
                    <v-text-field
                        id="meta title"
                        :label="$t('page.save.form.meta_title')"
                        name="meta title"
                        :rules="[
                            rules.min_length(3),
                            rules.max_length(255),
                        ]"
                        counter="255"
                        color="primary"
                        type="text"
                        v-model="page.meta_title"
                    ></v-text-field>
                    <!-- Meta keyword -->
                    <v-text-field
                        id="meta keyword"
                        :label="$t('page.save.form.meta_keyword')"
                        color="primary"
                        name="meta keyword"
                        :rules="[
                            rules.min_length(3),
                            rules.max_length(255),
                        ]"
                        counter="255"
                        type="text"
                        v-model="page.meta_keyword"
                    ></v-text-field>
                    <!-- Meta Description -->
                    <v-text-field
                        id="meta description"
                        :label="$t('page.save.form.meta_description')"
                        color="primary"
                        name="meta description"
                        :rules="[
                                rules.min_length(3),
                                rules.max_length(255),
                                ]"
                        counter="255"
                        type="text"
                        v-model="page.meta_description"
                    ></v-text-field>
                    <!-- Published -->
                    <v-checkbox v-model="page.published" color="primary" :label="page.published?$t('screener.save.form.published'):$t('screener.save.form.unpublished')"></v-checkbox>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn color="secondary" dark @click="savePage">Save</v-btn>
            </v-card-actions>   
        </v-card>
    </div>  
</template>

<script>
import rules from "@/validation";
export default {
    name:"AdminPageOverview",
    props: {
        page: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            rules,
        };
    },
    methods:{
        savePage(){
            if (!this.$refs.form.validate()) {
                return false;
            }
            this.$emit('onSave', this.page)
        }
    }
}
</script>

<style>

</style>